import { getPercentMeasurements } from '../../../CardDesignerCardElements/CardDesignerCardElementFrame/helpers';
import { ORIENTATION } from '../../../../../../../services/cards/constants';

export const getCardPhotoSlots = ({ cardPrintSize, cardOrientation }) => {
  if (!cardPrintSize?.width || !cardPrintSize?.height || !cardOrientation) {
    return [];
  }

  return [
    {
      label: '3" x 5"',
      width: 3,
      height: 5,
      orientation: ORIENTATION.PORTRAIT,
      input: {
        frame: {
          x: 0.25,
          y: 0.25,
          ...getPercentMeasurements(3, 5, cardPrintSize, cardOrientation),
        },
      },
    },
    {
      label: '5" x 3"',
      width: 5,
      height: 3,
      orientation: ORIENTATION.LANDSCAPE,
      input: {
        frame: {
          x: 0.25,
          y: 0.25,
          ...getPercentMeasurements(5, 3, cardPrintSize, cardOrientation),
        },
      },
    },
    {
      label: '5" x 7"',
      width: 5,
      height: 7,
      orientation: ORIENTATION.PORTRAIT,
      input: {
        frame: {
          x: 0.25,
          y: 0.25,
          ...getPercentMeasurements(5, 7, cardPrintSize, cardOrientation),
        },
      },
    },
    {
      label: '7" x 5"',
      width: 7,
      height: 5,
      orientation: ORIENTATION.LANDSCAPE,
      input: {
        frame: {
          x: 0.25,
          y: 0.25,
          ...getPercentMeasurements(7, 5, cardPrintSize, cardOrientation),
        },
      },
    },
    {
      label: '3" x 4"',
      width: 3,
      height: 4,
      orientation: ORIENTATION.PORTRAIT,
      input: {
        frame: {
          x: 0.25,
          y: 0.25,
          ...getPercentMeasurements(3, 4, cardPrintSize, cardOrientation),
        },
      },
    },
    {
      label: '4" x 3"',
      width: 4,
      height: 3,
      orientation: ORIENTATION.LANDSCAPE,
      input: {
        frame: {
          x: 0.25,
          y: 0.25,
          ...getPercentMeasurements(4, 3, cardPrintSize, cardOrientation),
        },
      },
    },
    {
      label: '3" x 3"',
      width: 3,
      height: 3,
      orientation: ORIENTATION.LANDSCAPE,
      input: {
        frame: {
          x: 0.25,
          y: 0.25,
          ...getPercentMeasurements(3, 3, cardPrintSize, cardOrientation),
        },
      },
    },
    {
      label: '2" x 2"',
      width: 2,
      height: 2,
      orientation: ORIENTATION.LANDSCAPE,
      input: {
        frame: {
          x: 0.25,
          y: 0.25,
          ...getPercentMeasurements(2, 2, cardPrintSize, cardOrientation),
        },
      },
    },
  ];
};

export const getCardTeamPhotoSlots = ({ cardPrintSize, cardOrientation }) => {
  if (!cardPrintSize?.width || !cardPrintSize?.height || !cardOrientation) {
    return [];
  }

  return [
    {
      label: '5" x 4"',
      width: 5,
      height: 4,
      badgeText: 'TEAM',
      tooltip: 'TEAM slots will always maintain a 5:4 aspect ratio.',
      orientation: ORIENTATION.LANDSCAPE,
      input: {
        frame: {
          x: 0.25,
          y: 0.25,
          ...getPercentMeasurements(5, 4, cardPrintSize, cardOrientation),
        },
      },
    },
  ];
};
